//
// ┌─────────────────────┐
// │ DO NOT EDIT BY HAND │
// └─────────────────────┘
//
// Generated by build.mjs in zinnia-icons
//
import { mapPropsToSvgProps, Props } from "../utils";
function IconArrowOffsite(iconProps: Props) {
  const props = mapPropsToSvgProps(iconProps);
  return <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M5 3H3V21H21V19H5V3Z" fill="currentColor" /><path d="M12 3L10 5H17.59L9.29004 13.29L10.71 14.71L19 6.41V14L21 12V3H12Z" fill="currentColor" /></svg>;
}
export default IconArrowOffsite;